import r from"styled-components";import{COLORS as e}from"../../constants/Theme.js";const o=r.div`
	width: ${r=>(null==r?void 0:r.width)||"100%"};
	display: flex;
	flex-direction: column;
	border: ${r=>r.showBorders?"1px solid "+e.stroke.primary:""};
	border-color: ${r=>r.borderColor||e.stroke.primary};
	border-radius: ${r=>r.borderRadius?r.borderRadius:r.showBorders?"4px":""};
	background: ${r=>r.backgroundColor||"unset"};
	.accordion {
		&__overview {
			display: flex;
			flex-direction: column;
			gap: 4px;
			padding: ${r=>r.headerPadding?r.headerPadding:"24px"};
			border-bottom: ${r=>r.showBorders&&r.isActive?"1px solid "+e.stroke.primary:""};
			border-color: ${r=>r.borderColor||e.stroke.primary};
			&__header {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
			}
			&__title-wrapper {
				display: flex;
				gap: 8px;
			}
			:hover {
				background: ${r=>r.skipHoverState?null:e.surface.subdued};
				border-radius: ${r=>r.skipHoverState?null:"4px"};
			}
		}
		&__content {
			${r=>r.isActive?{margin:(null==r?void 0:r.contentMargin)||"0px"}:{}};
			overflow: ${r=>r.hasChildrenMaxHeight?"scroll":"hidden"};
			max-height: 0;
			order: ${r=>"UP"===r.openDirection?-1:0};
		}
	}
`,d=r.div`
	display: flex;
	align-items: center;
	gap: 24px;
`;export{d as AccordionHeaderGroup,o as default};
